import styled from 'styled-components'

import CHeader from '../../components/Header'
import CFooter from '../../components/Footer'

export const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-flow: column;
  align-items: stretch;
  justify-content: space-between;
  background-color: white;
`

export const Header = styled(CHeader)``

export const Footer = styled(CFooter)``
